import { SystemCredentialsAction } from "us.common/actions";
import { call, put, takeLatest } from "redux-saga/effects";
import * as API from "us.common/services";
import { SystemCredentialsActionTypes } from "us.common/constants";

const { AuthorizationProfile } = API.UserAuthorization;
const { userCredentials } = SystemCredentialsAction;

const systemCredentialsSaga = {
  get: function* (action: any) {
    const params = action.payload?.data;
    try {
      const { data, status } = yield call(AuthorizationProfile.get, params);
      if (status === 200) {
        yield put(userCredentials.success(data));
      } else {
        yield put(userCredentials.fail(data));
      }
    } catch (error) {
      yield put(userCredentials.fail(error as any));
    }
  },
};

export default [
  takeLatest(
    SystemCredentialsActionTypes.GET_SYSTEM_CREDENTIALS,
    systemCredentialsSaga.get
  ),
];
